import { PAGINATION_LIMIT, RESOURCE } from '@src/constants';
import { omitIsNil } from '@src/utils/omit';
import api from './api';

export const getProjects = async ({
  search,
  offset,
  limit = PAGINATION_LIMIT,
  fields,
  sort,
}) => {
  const params = omitIsNil({
    search,
    offset,
    limit,
    fields,
    sort,
  });
  const response = await api({
    method: 'GET',
    url: RESOURCE.PROJECTS,
    params,
  });
  return response;
};

export const createProject = async (data) => {
  const response = await api({
    method: 'POST',
    url: RESOURCE.PROJECTS,
    data,
  });
  return response;
};

export const deleteProject = async (projectId) => {
  const response = await api({
    method: 'DELETE',
    url: `${RESOURCE.PROJECTS}/${projectId}`,
  });
  return response;
};

export const updateProject = async (projectId, data) => {
  const response = await api({
    method: 'PUT',
    url: `${RESOURCE.PROJECTS}/${projectId}`,
    data,
  });
  return response;
};

export const getProject = async (projectId) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.PROJECTS}/${projectId}`,
  });

  return response;
};

export const getJoinedAudio = async (projectId, mode) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.PROJECTS}/${projectId}/audio?mode=${mode}`,
  });

  return response;
};

export const getSampleProject = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.PROJECTS}/sample`,
  });

  return response;
};
